<template>
  <v-simple-table fixed-header>
    <template>
      <thead style="background-color: #f8f8f8">
        <tr>
          <th class="text-subtitle-2 text-center" style="width: 5%">STT</th>
          <th class="text-subtitle-2 text-left" style="width: 35%">Tên</th>
          <th class="text-subtitle-2 text-left" style="width: 10%">Ngày sinh</th>
          <th class="text-subtitle-2 text-center" style="width: 25%">
            <div class="d-flex align-center justify-center">
              Học Offline
              <v-checkbox
                v-model="statusAll"
                class="ml-2 mt-0"
                hide-details
                dense
                @change="toggleAllAttendance"
              ></v-checkbox>
            </div>
          </th>
          <th v-if="isHybrid" class="text-subtitle-2 text-center" style="width: 25%">
            <div class="d-flex align-center justify-center">
              Học Online
              <v-checkbox
                v-model="statusAllOnline"
                class="ml-2 mt-0"
                hide-details
                dense
                @change="toggleAllOnline"
              ></v-checkbox>
            </div>
          </th>
        </tr>
      </thead>
      <tbody v-if="data.length">
        <tr v-for="(item, index) in data" :key="item.id">
          <td class="text-center">{{ index + 1 }}</td>
          <td>
            <div class="text-none text-decoration-none primary--text">
              {{ item.student.name }}
            </div>
            <div>{{ item.student.code_short }}</div>
          </td>
          <td>{{ item.student.dob | ddmmyyyy }}</td>
          <td class="text-center">
            <v-chip
              :color="item.isAttended ? 'success' : 'secondary'"
              small
              @click="toggleAttendance(item)"
            >
              Có mặt
            </v-chip>
          </td>
          <td v-if="isHybrid" class="text-center">
            <v-chip
              :color="item.isOnline ? 'success' : 'secondary'"
              small
              @click="toggleOnline(item)"
            >
              Có mặt
            </v-chip>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="4">
            <div class="d-flex flex-column align-center py-4">
              <div class="mb-2">Chưa có dữ liệu học sinh trong lớp</div>
              <v-btn
                color="primary"
                text
                @click="$router.push(`/class/${classData.id}`)"
              >
                <v-icon left>mdi-plus</v-icon>
                Thêm học viên
              </v-btn>
            </div>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/plugins/utils.js'
import get from 'lodash-es/get'
export default {
  props: {
    isStatusShown: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      statusAll: false,
      statusAllOnline: false,
      data: [],
    }
  },
  computed: {
    ...mapState({
      isHybrid(state) {
        return get(state['class'].clazz, 'metadata.classMode') === 'hybrid'
      },
      attendances(state) {
        return state['lessonAttendance'].attendances.filter(att => att.student && att.student.status === 'active')
      },
      classData(state) {
        return state['class'].clazz
      },
      originList() {
        return this.attendances.map((s) => ({
          ...s,
          isAttended: s.status === 'attended' && !s.isOnline,
          isOnline: s.isOnline,
          tags: utils.clearUnicodeWithDivider(s.student.name),
        }))
      },
    }),
  },
  methods: {
    toggleAllAttendance(value) {
      this.statusAllOnline = false
      this.data.forEach(item => {
        item.isAttended = value
        item.isOnline = false
      })
    },
    toggleAllOnline(value) {
      this.statusAll = false
      this.data.forEach(item => {
        item.isAttended = false
        item.isOnline = value
      })
    },
    toggleAttendance(item) {
      item.isAttended = !item.isAttended
      this.statusAll = this.data.every(item => item.isAttended)
      this.statusAllOnline = false
      if (item.isAttended === true) {
        item.isOnline = false
      }
    },
    toggleOnline(item) {
      item.isOnline = !item.isOnline
      this.statusAll = false
      this.statusAllOnline = this.data.every(item => item.isOnline)
      if (item.isOnline === true) {
        item.isAttended = false
      }
    },
    getData() {
      return this.data
    },
    handleSearch(search) {
      if (typeof search === 'string' && search.length) {
        this.data = this.originList.filter((x) => x.tags.includes(search))
      } else {
        this.data = [...this.originList]
      }
    },
  },
  watch: {
    originList: {
      handler(val) {
        if (val) {
          this.data = val
          this.statusAll = this.data.every(item => item.isAttended)
        }
      },
      immediate: true,
      deep: true,
    },
    search: {
      handler(val) {
        this.handleSearch(val)
      },
      immediate: true,
    },
  },
}
</script>
